import { KBarProvider } from 'kbar';
import useCommandBarActions from './command-bar-actions';
import CommandBarSearch from './search';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CommandBar = function CommandBar(_ref) {
  var children = _ref.children;
  var actions = useCommandBarActions();
  return /*#__PURE__*/_jsxs(KBarProvider, {
    actions: actions,
    children: [/*#__PURE__*/_jsx(CommandBarSearch, {}), children]
  });
};

export default CommandBar;